import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { Brand, Neutrals } from '@/constants/theme';

export interface GroceryNoListsEmptyStateProps {
  onCreateList?: () => void;
}

export function GroceryNoListsEmptyState({ onCreateList }: GroceryNoListsEmptyStateProps) {
  return (
    <View style={styles.emptyContainer}>
      <Ionicons name="cart-outline" size={64} color={Neutrals.textMuted} />
      <Text style={styles.emptyTitle}>No grocery lists yet</Text>
      <Text style={styles.emptySubtitle}>Create your first list to get started</Text>
      {onCreateList && (
        <TouchableOpacity onPress={onCreateList} style={styles.emptyButton}>
          <Ionicons name="add" size={20} color="#fff" />
          <Text style={styles.emptyButtonText}>Create List</Text>
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  emptyContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
  },
  emptyTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: Neutrals.textPrimary,
    marginTop: 16,
    marginBottom: 8,
  },
  emptySubtitle: {
    fontSize: 16,
    color: Neutrals.textSecondary,
    marginBottom: 24,
    textAlign: 'center',
  },
  emptyButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: Brand.primary,
    borderRadius: 12,
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  emptyButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 20,
  },
});
